module.exports = __webpack_public_path__ + "img/house.bfca5eaf.jpg";